export default __webpack_public_path__ + "static/media/horizontalLogo.6d63357b.png";